export const IS_USER_BIRTHDAY = 'jbUserBirthdayToday';
export const IS_USER_MOSAIC = 'jbUserIsMosaic';
export const CARD_STATUS = 'cardStatus';
export const COUNTRY_CODE = 'jbCountryCode';
